<template>
  <v-tooltip bottom :disabled="!tooltipMessage">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-btn
          color="background"
          elevation="3"
          class="primary--text mx-0"
          @click="triggerFileUpload"
          :disabled="disabled"
        >
          <v-icon left>mdi-upload</v-icon>
          {{ $t("migrationCreationCSV.buttonUpload") }}
        </v-btn>
        <input
          ref="fileInput"
          type="file"
          class="d-none"
          accept=".csv"
          @change="handleFile"
        />
      </span>
    </template>
    <span>
      {{ tooltipMessage }}
    </span>
  </v-tooltip>
</template>

<script>
import { labels } from "@/helpers/variables/migrations";
import Papa from "papaparse";

export default {
  name: "CsvMigrationUploader",
  data() {
    return {
      loading: false,
    };
  },
  props: {
    disabled: { type: Boolean, default: false },
    tooltipMessage: { type: String, default: null },
  },
  methods: {
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    handleFile({ target }) {
      const file = target.files[0];
      if (!file) return;
      this.parseCsv(file);
      this.$refs.fileInput.value = "";
    },

    parseCsv(file) {
      this.loading = true;
      const fileName = file.name;
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const mapped = results.data
            .map((row) => {
              return {
                source_email: row[labels.source_email]?.trim() || "",
                target_email: row[labels.target_email]?.trim() || "",
                // TODO: campos de drive
                shared_with: row[labels.shared_with]
                  ? row[labels.shared_with]
                      .split(/[\s,;]+/)
                      .map((e) => e.trim())
                      .filter((e) => !!e)
                  : [],
                period: this.convertDate(row[labels.period]?.trim() || ""),
              };
            })
            .filter((item) => {
              const allFieldsEmpty =
                !item.source_email &&
                !item.target_email &&
                item.shared_with.length === 0 &&
                !item.period;

              return !allFieldsEmpty;
            });

          this.loading = false;
          this.$emit("content", mapped);
          this.$emit("fileName", fileName);
        },
        error: (err) => {
          this.loading = false;
          this.$emit("error", "Erro ao ler o arquivo CSV, parseCsv()");
          console.error("Erro ao ler o arquivo CSV, parseCsv()", err);
        },
      });
    },

    convertDate(dateStr) {
      if (!dateStr) return "";

      const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        const [, yyyy, mm, dd] = isoMatch;
        return `${dd}/${mm}/${yyyy}`;
      }

      const brMatch = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (brMatch) {
        return dateStr;
      }

      return dateStr;
    },
  },
};
</script>
